import { Badge } from '@reflex/ui/components/ui/badge';
import { cn } from '@reflex/ui/lib/utils';

interface IconBadgeProps {
  icon: React.ComponentType<{ className?: string }>;
  children: React.ReactNode;
  variant?: 'outline' | 'secondary';
  className?: string;
}

export function IconBadge({
  icon: Icon,
  children,
  variant = 'outline',
  className,
}: IconBadgeProps) {
  return (
    <Badge variant={variant} className={cn('gap-1.5 py-1 text-xs font-normal', className)}>
      <Icon className="h-3.5 w-3.5" />
      {children}
    </Badge>
  );
}
